import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesReceiptMain } from './modules/ui/Main';

const ReceiptPage = (
  <SuspensePage>
    <PagesReceiptMain />
  </SuspensePage>
);

export default ReceiptPage;
